import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_SERVICE, API_KEYS } from '../api';
import { useShowToast } from '@/hooks';
import { getRequisitionErrorMessage } from '../utils/requisitionErrorHandler';

interface AssociateJobParams {
  requisitionId: string;
  jobId: number;
  applyToGroup?: boolean;
}

export const useAssociateJobToRequisition = () => {
  const queryClient = useQueryClient();
  const toast = useShowToast();

  return useMutation({
    mutationFn: ({
      requisitionId,
      jobId,
      applyToGroup,
    }: AssociateJobParams) => {
      const payload: any = {
        ats_job_id: jobId,
      };

      // Add apply_to_group if needed
      if (applyToGroup) {
        payload.apply_to_group = true;
      }

      return API_SERVICE.associateJobToRequisition(requisitionId, payload);
    },

    onSuccess: (_, { requisitionId }) => {
      queryClient.invalidateQueries({
        queryKey: [API_KEYS.getRequisition, requisitionId.toString()],
      });
      queryClient.invalidateQueries({
        queryKey: [API_KEYS.getRequisitions],
      });

      toast({
        title: 'Job associated successfully',
      });
    },

    onError: (error: any) => {
      const errorMessage = getRequisitionErrorMessage(error, false);
      toast({
        title: 'Failed to associate job',
        description: errorMessage || 'Please try again',
        status: 'error',
      });
    },
  });
};
